<template>
    <div class="alert alert-dark">
        <div class="alert-heading">
                <b v-if="route.type == 'Exact' || type != 2">{{route.referenceModel.VehicleReferenceModelManuelName}}</b>
                <b-form-checkbox v-else v-model="route.selected"><b>{{route.referenceModel.VehicleReferenceModelManuelName}}</b></b-form-checkbox>
            </div>
        <div class="alert-body">
            <div class="row align-items-center justify-content-between">
                <div class="col-xl-6 offset-xl-1 mb-1 mb-xl-0">
                    <draft-price-location-drawer :draw-route-data="drawRouteData"></draft-price-location-drawer>
                </div>
                <div class="col-xl-3 mb-1 mb-xl-0">
                    <table>
                        <tr v-if="type == 2">
                            <td>
                                <div class="d-flex align-items-center text-nowrap">
                                    <span class="material-icons-round draft-price-icons text-success">attach_money</span>
                                    <b>Paralı Yollar&nbsp;</b> 
                                </div>
                            </td>
                            <td>
                                <div class="text-nowrap">:
                                    <span v-if="route.isAvoidTolls === true">Dahil</span>
                                    <span v-else>Dahil Değil</span> 
                                </div>
                            </td>
                        </tr>
                        <tr v-if="type == 2">
                            <td>
                                <div class="d-flex align-items-center text-nowrap">
                                    <span class="material-icons-round draft-price-icons text-primary">toll</span>
                                    <b>Anayollar&nbsp;</b> 
                                </div>
                            </td>
                            <td>
                                <div class="text-nowrap">:
                                    <span v-if="route.isAvoidHighways === true">Dahil</span>
                                    <span v-else>Dahil Değil</span> 
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="d-flex align-items-center  text-nowrap">
                                    <span class="material-icons-round draft-price-icons text-warning">date_range</span>
                                    <b>Çalışılan Gün&nbsp;</b>
                                </div>
                            </td>
                            <td>
                                <div class="text-nowrap">:
                                    <b>{{route.countOfDaysWorked }}</b>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="d-flex align-items-center  text-nowrap">
                                    <span class="material-icons-round draft-price-icons text-danger">restart_alt</span>
                                    <b>Sefer Sayısı&nbsp;</b>
                                </div>
                            </td>
                            <td>
                                <div class="text-nowrap">:
                                    <b>{{route.countOfTrips }}</b>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="col-xl-auto">
                    <div class="d-flex flex-column justify-content-center">
                        <button v-if="!route.hasIdle && type == 2" v-b-tooltip.noninteractive.hover.bottom title="Aylak Rota Ekle" v-on:click="$emit('edit-idle',route)" class="btn btn-primary btn-icon btn-sm mb-25">
                            <feather-icon icon="GitCommitIcon"></feather-icon>
                        </button>
                        <button v-if="route.hasIdle && type == 2" v-on:click="$emit('remove-idle',route)" v-b-tooltip.noninteractive.hover.bottom title="Aylak Rota Sil" class="btn btn-info btn-icon btn-sm mb-25">
                            <feather-icon icon="XCircleIcon"></feather-icon>
                        </button>
                        <button v-on:click="$emit('show-route',route)" v-b-tooltip.noninteractive.hover.bottom title="Haritada Gör" class="btn btn-warning btn-icon btn-sm mt-25 mb-25">
                            <feather-icon icon="MapIcon"></feather-icon>
                        </button>
                        <button v-on:click="$emit('delete',route)" v-b-tooltip.noninteractive.hover.bottom title="Sil" class="btn btn-danger btn-icon btn-sm mt-25 mb-25">
                            <feather-icon icon="TrashIcon"></feather-icon>
                        </button>
                        <button v-on:click="$emit('change-detail',route)" v-b-tooltip.noninteractive.hover.bottom title="Düzenle" class="btn btn-secondary btn-icon btn-sm mt-25">
                            <feather-icon icon="Edit2Icon"></feather-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {BFormCheckbox} from 'bootstrap-vue'
import DraftPriceLocationDrawer from './DraftPriceLocationDrawer'
import {VBTooltip} from 'bootstrap-vue'
export default {
    components:{
        BFormCheckbox,
        DraftPriceLocationDrawer
    },
    directives:{
        "b-tooltip":VBTooltip
    },
    props:{
        route:{
            type:Object,
            required:true
        },
        type:Number
    },
    computed:{
        drawRouteData(){
            let data = { routes:[], distances:[], totalDistance:0 }
            data.routes.push({province:this.route.startProvince?.Name,district:this.route.startDistrict?.Name,neighbourhood:this.route.startNeighbourhood?.Name})
            
            if(!!this.route?.hasIdle){
                data.routes.push({province:this.route.endProvince?.Name, district:this.route.endDistrict?.Name,neighbourhood:this.route.endNeighbourhood?.Name})
                data.routes.push({province:this.route.idleProvince?.Name,district:this.route.idleDistrict?.Name,neighbourhood:this.route.idleNeighbourhood?.Name})
                data.distances.push(this.route.calculatedDistance)
                data.distances.push(this.route.idleDistance - this.route.calculatedDistance)
                data.totalDistance = this.route.idleDistance
            }else{
                data.routes.push({province:this.route.endProvince?.Name,district:this.route.endDistrict?.Name,neighbourhood:this.route.endNeighbourhood?.Name})
                data.distances.push(this.route.calculatedDistance)
                data.totalDistance = this.route.calculatedDistance
            }
            return data
        }
    }
}
</script>

<style>
    .draft-price-icons{
        width: 30px;
    }
</style>